import catalog from './catalog.json' with { type: 'json' };
import sample from './sample.json' with { type: 'json' };
import { receiptIdentity } from './receiptIdentity.js';
import { renderTemplate, resolveTemplate } from './templateEngine.js';
export { catalog };

const money = value => Number(value || 0).toFixed(2);
const qty = value => String(Math.round(Number(value || 0) * 1000) / 1000);

export function receiptData(task = {}, context = {}) {
  const order = task.salesOrder || {};
  const shipping = order.shipping || {};
  const items = (task.items || order.items || []).map(item => ({
    name: item.name || '未命名商品', specText: item.specText || item.selectedSpec?.name || '', commit: item.commit || '',
    qty: qty(item.qty), price: money(item.price), subtotal: money(Number(item.price) * Number(item.qty)),
  }));
  const tableName = [task.table?.zone || order.table?.zone, task.table?.name || order.table?.name].filter(Boolean).join(' ');
  const payment = order.payment || {};
  const paymentParts = [
    payment.payByCash?.channel ? `${payment.payByCash.channel}${payment.payByCash.amount != null ? ` ¥${money(payment.payByCash.amount)}` : ''}` : '',
    payment.payByBalance > 0 ? `余额 ¥${money(payment.payByBalance)}` : '',
    payment.payByPoints > 0 ? `积分 ${payment.payByPoints}` : '',
    ...(payment.payByCoupons || []).map(coupon => `${coupon.name || '卡券'} ×${qty(coupon.balanceReduce)}`),
  ].filter(Boolean);
  const orderNumber = String(order.dailySerial || order.localOrderNo || order._id || '');
  return {
    testMark: '', shopName: context.shopName || task.shop?.name || order.shop?.name || '销售小票',
    chainName: context.chainName || task.shop?.chain?.name || order.shop?.chain?.name || '',
    orderNumber, time: order.created || task.created || '', tableName,
    salePoint: order.salePoint || '', fulfillment: [shipping.type, shipping.status].filter(Boolean).join(' '),
    customerName: order.customer?.person?.name || order.customer?.name || '散客', staffName: context.staffName || '',
    amount: money(order.amount), payment: paymentParts.join(' / ') || payment.status || '',
    ...receiptIdentity(order.customer, shipping, tableName),
    subject: tableName ? `桌台：${tableName}` : `订单号：${orderNumber}`, person: task.table?.dining?.person ? String(task.table.dining.person) : '',
    action: task.action || '厨打', totalQty: qty(items.reduce((sum, item) => sum + Number(item.qty), 0)), items,
  };
}

export function templateDocument(kind, data, formats) {
  return renderTemplate(resolveTemplate(catalog, formats, kind), data);
}

export function sampleDocument(kind, formats, context = {}) {
  return templateDocument(kind, { ...sample, ...context, testMark: sample.testMark }, formats);
}

export function formatTaskDocuments(task, context = {}) {
  const data = receiptData(task, context);
  if (task.kind === 'cupLabel') {
    const cups = data.items.filter(item => Number(item.qty) > 0).flatMap(item => Array.from({ length: Math.max(1, Math.round(Number(item.qty))) }, () => item));
    return cups.map((item, i) => templateDocument('cupLabel', {
      ...data, ...item, index: String(i + 1), total: String(cups.length), fulfillment: data.fulfillment || '自提',
    }, context.receiptFormats));
  }
  if (!['frontReceipt', 'kitchen'].includes(task.kind)) return [];
  return [templateDocument(task.kind, data, context.receiptFormats)];
}
